import { Either } from 'fp-ts/lib/Either'

import { CartItem } from '@/models/cart/cart-item'
import { NoveltyEntity } from '@spa/components/organisms/cart/novelty/selection'

export class CommandToSaveNoveltySpec {
  static create(map: CommandMap): CommandToSaveNoveltySpec {
    return new CommandToSaveNoveltySpec(map)
  }
  private constructor(private readonly map: CommandMap) { }

  select(
    novelty: NoveltyEntity,
    cartItems: CartItem[]
  ): () => CommandResult {
    const noveltyCartItems = cartItems.filter(c => c.isNovelty)
    const cartItem = noveltyCartItems.find((c) => {
      return c.skuId === novelty.item.skuId
    })

    if (!cartItem) {
      if (novelty.state.count === 0) {
        return () => this.map.default(novelty, null)
      }

      return () => this.map.create(novelty)
    }
    if (novelty.state.count === 0) {
      return () => this.map.delete(novelty, cartItem)
    }

    if (novelty.state.count !== cartItem.unitCount) {
      return () => this.map.update(novelty, cartItem)
    }

    return () => this.map.default(novelty, cartItem || null)
  }
}

export type CommandResult = Promise<Either<Error, null>>
export interface CommandMap {
  create(noveltySection: NoveltyEntity): CommandResult
  update(noveltySection: NoveltyEntity, cartItem: CartItem): CommandResult
  delete(noveltySection: NoveltyEntity, cartItem: CartItem): CommandResult
  default(noveltySection: NoveltyEntity, cartItem: CartItem | null): CommandResult
}
